import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {InfoBox} from './InfoBox';
import {Column} from '../../../../../components/Column/Column';
import {orangeColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  website: string;
  size: string;
  companyType: string;
  percentOfWomen: string;
  branch: string;
  mainLocation: string;
  workMode: string;
  percentParents: string;
  averageAge: string;
  language: string;
}
export const CompanyOverview = ({
  companyType,
  averageAge,
  branch,
  mainLocation,
  size,
  percentOfWomen,
  percentParents,
  website,
  workMode,
  language,
}: Props) => {
  const textColor = orangeColors[100];
  const {t: ta} = useTranslation('translation', {keyPrefix: 'applicantDashboard.matchDetailsView.companyDetails'});
  const {t: tc} = useTranslation('translation', {
    keyPrefix: 'companyProfile.generalInformation.dialog.select.language',
  });
  const formatPercentageValue = (text: string) => {
    if (text === '-') {
      return text;
    }

    return `${text}%`;
  };

  const languageText = tc(language);
  const isLargeCompany = size === '250';

  return (
    <Grid item padding='32px' sx={{padding: {xs: '16px', sm: '32px'}}}>
      <Typography variant='h3' paddingBottom='16px'>
        {ta('overview')}
      </Typography>
      <Grid
        container
        display='flex'
        justifyContent='space-between'
        sx={{
          flexDirection: {xs: 'column', sm: 'row', md: 'row'},
        }}
      >
        <Column>
          <InfoBox testId={'website-info'} title={ta('website')} text={website} color={textColor} />
          <InfoBox title={ta('size')} text={isLargeCompany ? `${size}+` : size} color={textColor} />
          <InfoBox title={ta('language')} text={languageText} color={textColor} />
          <InfoBox title={ta('companyType')} text={companyType} color={textColor} />
          <InfoBox title={ta('percentOfWomen')} text={formatPercentageValue(percentOfWomen)} color={textColor} />
        </Column>
        <Column>
          <InfoBox title={ta('branch')} text={branch} color={textColor} />
          <InfoBox title={ta('mainLocation')} text={mainLocation} color={textColor} />
          <InfoBox title={ta('workMode')} text={workMode} color={textColor} />
          <InfoBox title={ta('percentParents')} text={formatPercentageValue(percentParents)} color={textColor} />
          <InfoBox title={ta('averageAge')} text={averageAge} color={textColor} />
        </Column>
      </Grid>
    </Grid>
  );
};
